import { FlowGrid, Separator, Skeleton, Toggle } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ConclusionContainer from '../../components/ConclusionContainer'

function ConclusionSkeleton(): JSX.Element {
  return (
    <ConclusionContainer>
      <Skeleton.Paragraph lineCount={2} size="md" />
    </ConclusionContainer>
  )
}

type Props = {
  columns: number
}

export default function VitalsLoading({ columns }: Props): JSX.Element {
  const [t] = useTranslation()
  const isOneColumn = columns >= 7
  return (
    <>
      <Toggle
        aria-label={t('tree-person.show-contributor-details.label')}
        data-testid="vitals-detail-view"
        label={t('tree-person.detail-view.label')}
        disabled
      />
      <Separator size="nano" />
      <FlowGrid guttersY="nano" orientation="vertical" columnCount={isOneColumn ? 1 : 2}>
        <ConclusionSkeleton />
        <ConclusionSkeleton />
        <ConclusionSkeleton />
        <ConclusionSkeleton />
        <ConclusionSkeleton />
        <ConclusionSkeleton />
      </FlowGrid>
      <Separator size="nano" />
    </>
  )
}
